import React from 'react';
import s from './style.module.css';
import { connect } from 'react-redux';

import Form from '../../components/form';

import { updateNextButton } from '../../actions/global-actions';
import { updatePersonalInformation } from '../../actions/page2-actions';
import { queryParams } from '../../utils';

class Page2 extends React.Component {
	constructor(props) {
		super(props);
		this.handleValues = this.handleValues.bind(this);
	}

  	componentWillMount() {
  		this.props.updateNextButton(false)
  	}

	handleValues(fields, valid) {
		this.props.updatePersonalInformation(fields)
		if(valid) {
			this.props.updateNextButton(true)
		} else {
			this.props.updateNextButton(false)
		}
	}

	componentDidMount() {
		const q = queryParams();
		if (q.iframe) {
			window.parent.postMessage({
				type: 'pageUpdate',
				payload: 'PERSONAL_DETAILS'
			}, '*');
		}
	}

	render(props) {
		return (
			<div className={s.content}>
				<Form
					onSubmitValues={this.handleValues.bind(this)} 
					personalInformation={
						{
							firstname: this.props.firstname,
							lastname: this.props.lastname,
							email: this.props.email,
							phone: this.props.phone,
							country: this.props.country,
							company: this.props.company,
							industry: this.props.industry,
							companysize: this.props.companysize,
							description: this.props.description,
							newsletter: this.props.newsletter
						}
					}
				/>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	const { 
		firstname,
    	lastname,
    	email,
    	phone,
		country,
		company,
		industry,
		companysize,
		description,
		newsletter,
	} = state.page2;
	const { nextBtn } = state.global;
	return { nextBtn, firstname, lastname, email, phone, country, company, industry, companysize, description, newsletter};
}

export default connect(mapStateToProps, {updateNextButton, updatePersonalInformation})(Page2);
